import FootballStatsCategory from "../../../../stats/football-stats-category";
import MissedFieldGoalReturnStats from "./missed-field-goal-return-stats";

export default class CflMissedFieldGoalReturnStats extends MissedFieldGoalReturnStats {
    getStatCategory() {
        return FootballStatsCategory.PUNT_RETURN;
    }
}
